module.exports = __webpack_public_path__ + "img/gen-box-bg-C9N-vsd0.5f46ec6f.png";